import apiClient from './client';

function withParams(base, params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.set(k, String(v));
  });
  const s = qs.toString();
  return s ? `${base}?${s}` : base;
}

export const schwabApi = {
  getStatus: async () => {
    const response = await apiClient.get('/api/schwab/status');
    return response.data;
  },

  startOAuth: async () => {
    const response = await apiClient.get('/api/schwab/oauth/start');
    return response.data;
  },

  disconnect: async () => {
    const response = await apiClient.post('/api/schwab/disconnect');
    return response.data;
  },

  getSummary: async () => {
    const response = await apiClient.get('/api/schwab/summary');
    return response.data;
  },

  getPositions: async () => {
    const response = await apiClient.get('/api/schwab/positions');
    return response.data;
  },

  getAccounts: async (includePositions = false) => {
    const qs = includePositions ? '?fields=positions' : '';
    const response = await apiClient.get(`/api/schwab/accounts${qs}`);
    return response.data;
  },

  getOrders: async (params = {}) => {
    const response = await apiClient.get(withParams('/api/schwab/orders', params));
    return response.data;
  },

  getOrder: async (orderId, accountNumber) => {
    const response = await apiClient.get(
      withParams(`/api/schwab/orders/${orderId}`, { accountNumber })
    );
    return response.data;
  },

  placeOrder: async (payload) => {
    const response = await apiClient.post('/api/schwab/orders', payload);
    return response.data;
  },

  previewOrder: async (payload) => {
    const response = await apiClient.post('/api/schwab/orders/preview', payload);
    return response.data;
  },

  cancelOrder: async (orderId, accountNumber) => {
    const response = await apiClient.delete(
      withParams(`/api/schwab/orders/${orderId}`, { accountNumber })
    );
    return response.data;
  },

  replaceOrder: async (orderId, payload) => {
    const response = await apiClient.put(`/api/schwab/orders/${orderId}`, payload);
    return response.data;
  },

  getTransactions: async (params = {}) => {
    const response = await apiClient.get(withParams('/api/schwab/transactions', params));
    return response.data;
  },

  getUserPreference: async () => {
    const response = await apiClient.get('/api/schwab/user-preference');
    return response.data;
  },
};
